import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import axios from 'axios';
import { CartProvider } from './context/CartContext';
import HomePage from './pages/HomePage';
import BookingPage from './pages/BookingPage';
import CartBookingPage from './pages/CartBookingPage';
import PaymentPage from './pages/PaymentPage';
import BookingStatus from './pages/BookingStatus';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import SubscriptionsPage from './pages/SubscriptionsPage';
import DisclaimerPopup from './components/DisclaimerPopup';
import '@/App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    let visitorId = localStorage.getItem('prayan_visitor_id');
    if (!visitorId) {
      visitorId = 'v_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('prayan_visitor_id', visitorId);
    }

    // Detect traffic source
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source') || '';
    const utmMedium = params.get('utm_medium') || '';
    const utmCampaign = params.get('utm_campaign') || '';
    const referrer = document.referrer || '';

    let source = 'direct';
    if (utmSource) {
      source = utmSource.toLowerCase();
    } else if (referrer) {
      const r = referrer.toLowerCase();
      if (r.includes('google')) source = 'google';
      else if (r.includes('facebook') || r.includes('fb.com')) source = 'facebook';
      else if (r.includes('instagram')) source = 'instagram';
      else if (r.includes('youtube')) source = 'youtube';
      else if (r.includes('whatsapp') || r.includes('wa.me')) source = 'whatsapp';
      else if (r.includes('twitter') || r.includes('x.com')) source = 'twitter';
      else if (r.includes('maps.google') || r.includes('google.com/maps')) source = 'google_maps';
      else source = new URL(referrer).hostname.replace('www.', '') || 'other';
    }

    // Save source for the session (first touch only)
    if (!sessionStorage.getItem('prayan_source')) {
      sessionStorage.setItem('prayan_source', source);
      sessionStorage.setItem('prayan_referrer', referrer);
      if (utmSource) sessionStorage.setItem('prayan_utm', JSON.stringify({ source: utmSource, medium: utmMedium, campaign: utmCampaign }));
    }

    const sessionSource = sessionStorage.getItem('prayan_source') || source;

    axios.post(`${API}/analytics/track`, {
      event: 'page_view',
      page: location.pathname,
      visitor_id: visitorId,
      source: sessionSource,
      referrer: referrer,
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}

function App() {
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(() => {
    return localStorage.getItem('prayan_disclaimer_accepted') === 'true';
  });

  const handleAcceptDisclaimer = () => {
    localStorage.setItem('prayan_disclaimer_accepted', 'true');
    setDisclaimerAccepted(true);
  };

  return (
    <CartProvider>
      <Router>
        <AnalyticsTracker />
        {!disclaimerAccepted && <DisclaimerPopup onAccept={handleAcceptDisclaimer} />}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/book/:poojaType" element={<BookingPage />} />
          <Route path="/cart" element={<CartBookingPage />} />
          <Route path="/payment/:bookingId" element={<PaymentPage />} />
          <Route path="/booking-status/:bookingId" element={<BookingStatus />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
